export default "__VITE_ASSET__BrrFUHoV__"